import { useEffect } from 'react';
import './styles.sass'

export const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className='faq unlogged-page'>
        <div className='content'>
          <div className="container">
            <h2 className='title'>🔧 FAQ – Emprega Mecânico</h2>

            <div className="faq-section">
              <h2>🔍 Visão Geral</h2>
              <div className="faq-item">
                <strong>❓ O que é o Emprega Mecânico?</strong>
                Uma plataforma gratuita da Escola do Mecânico que conecta alunos, ex-alunos e mecânicos formados a oportunidades de trabalho no setor automotivo — e ajuda empresas a encontrarem profissionais qualificados.
              </div>
              <div className="faq-item">
                <strong>💡 Como funciona?</strong>
                <ul>
                  <li><strong>Para candidatos:</strong> Cadastro + candidaturas → acompanhamento de processo seletivo em tempo real</li>
                  
                  <li><strong>Para empresas:</strong> Criação de vaga → recebimento de candidaturas → gerenciamento de processos seletivos</li>
                </ul>
              </div>
            </div>

            <div className="faq-section">
              <h2>👨‍🔧 Para Candidatos</h2>
              <div className="faq-item">
                <strong>📱 Como me cadastro?</strong>
                Baixe o app na <a href="https://play.google.com/store/apps/details?id=br.com.empregamecanico" target="_blank" rel="noreferrer">Google Play</a> ou na
                <a href="https://apps.apple.com/br/app/emprega-mec%C3%A2nico/id1551011373" target="_blank" rel="noreferrer">App Store</a>, preencha seu perfil e crie seu currículo.
              </div>
              <div className="faq-item">
                <strong>🎓 Quem pode se candidatar?</strong>
                Alunos e ex-alunos da Escola do Mecânico e mecânicos formados.
              </div>
              <div className="faq-item">
                <strong>🧰 Preciso ter experiência?</strong>
                Não obrigatoriamente. Aqui há espaço para todos, com muitas oportunidades abertas tanto para quem tem experiência quanto para quem está ingressando no mercado de trabalho.
              </div>
              <div className="faq-item">
                <strong>💼 Como acompanho minhas candidaturas?</strong>
                Pelo app, você será notificado sobre atualizações de processos seletivos ao qual tenha se candidatado.
              </div>
            </div>

            <div className="faq-section">
              <h2>🏭 Para Empresas</h2>
              <div className="faq-item">
                <strong>🧑‍💼 Como minha empresa pode anunciar vagas?</strong>
                Acesse <a href="https://empregamecanico.com.br" target="_blank" rel="noreferrer">empregamecanico.com.br</a>, clique em “Cadstro", "Empresa” e preencha o formulário.
              </div>
              <div className="faq-item">
                <strong>⚙️ A seleção é feita por quem?</strong>
                Pelo próprio anunciante da vaga, que receberá a candidatura e analisará seu perfil. Dica: mantenha seu perfil e currículo atualizados para maiores chances de aprovação!
              </div>
              <div className="faq-item">
                <strong>💸 Existe algum custo?</strong>
                Não. O serviço é 100% gratuito.
              </div>
            </div>

            <div className="faq-section">
              <h2>📲 Sobre o Aplicativo</h2>
              <div className="faq-item">
                <strong>📥 Onde posso baixar?</strong>
                <a href="https://play.google.com/store/apps/details?id=br.com.empregamecanico" target="_blank" rel="noreferrer">Google Play – Emprega Mecânico</a>
                <br/>
                <a href="https://apps.apple.com/br/app/emprega-mec%C3%A2nico/id1551011373" target="_blank" rel="noreferrer">App Store – Emprega Mecânico</a>
              </div>
              <div className="faq-item">
                <strong>📆 O app é atualizado com frequência?</strong>
                Sim! O aplicativo está em constante melhoria e novas atualizações são feitas regularmente, portanto, mantenha o seu aplicativo sempre atualizado para ter a melhor experiência.
              </div>
              <div className="faq-item">
                <strong>🔐 Meus dados estão seguros?</strong>
                Sim. Os dados são criptografados e você pode solicitar a exclusão diretamente pelo app.
              </div>
            </div>

            <div className="faq-section">
              <h2>🛠️ Suporte e Contato</h2>
              <table>
                <tr>
                  <th>Canal</th>
                  <th>Detalhes</th>
                </tr>
                <tr>
                  <td>📧 E-mail</td>
                  <td>suporte@empregamecanico.com.br</td>
                </tr>
                <tr>
                  <td>📞 Telefone</td>
                  <td>+55 (19) 97167-6982</td>
                </tr>
                <tr>
                  <td>📍 Endereço</td>
                  <td>Rua Júlio Frank de Arruda, 92 – Campinas/SP</td>
                </tr>
              </table>
            </div>

            <p className='last-text'>
              💬 Ainda com dúvidas? <a href="mailto:suporte@empregamecanico.com.br">Fale com a gente</a> ou acompanhe no 
              <a href="https://www.instagram.com/empregamecanicooficial/" target="_blank" rel="noreferrer">Instagram oficial</a>.
            </p>
          </div>
        </div>
    </div>
  )
}
